import { Auth } from "api/makeApiRequest";
import { addPostProcessingToResponse } from "api/utils/addPostProcessingToResponse";
import { validate, ValidationCallback } from "validation/validate";
import { captureException } from "services/captureException";

import {
	makePaginatedSearch,
	Params as MakePaginatedSearchParams
} from "./makePaginatedSearch";

type Params<
	RawQueryData,
	RawApiOutput,
	ProcessedApiOutput
> = MakePaginatedSearchParams<RawQueryData, RawApiOutput, ProcessedApiOutput>;

export const makePaginatedSearchWithCount = <
	RawQueryData extends { [k: string]: string | unknown | null | Date },
	RawApiOutput,
	ProcessedApiOutput = RawApiOutput
>({
	endPoint,
	flagValidationErrorsInRow,
	preProcessor,
	postProcessor,
	sort
}: Params<RawQueryData, RawApiOutput, ProcessedApiOutput>) => (
	data: RawQueryData,
	auth: Auth,
	cacheInMemory: boolean = false
) => {
	const req = makePaginatedSearch<
		RawQueryData,
		RawApiOutput,
		ProcessedApiOutput
	>({
		endPoint,
		flagValidationErrorsInRow,
		preProcessor,
		postProcessor,
		sort
	})(data, auth, cacheInMemory);

	return addPostProcessingToResponse(
		req,
		(result, requestPayload) => {
			const doValidate: ValidationCallback<{ count: number }> = (
				input,
				{ checkField }
			) => {
				checkField("count", { type: "number" });
			};

			if (
				!validate(result, {
					doValidate,
					auth,
					withErrors: errors => {
						throw captureException(new Error("Invalid data"), {
							evtType: "invalidApiData",
							extra: {
								result,
								requestPayload,
								errors
							}
						});
					}
				})
			) {
				throw new Error("Invalid response");
			}
			return result;
		},
		data
	);
};
